export const locationsMap = () => {

    const mapContainer = document.getElementById('map-container');

    if (mapContainer) {


    }
}